if( !Array.prototype.chunks ) Array.prototype.chunks = function ( chunk )
{
    let self = this

    let i, j

    const ret = []

    for( i=0, j=self.length; i<j; i+=chunk )
    {
        ret.push( self.slice( i, i + chunk ) )
    }

    return ret
}